import { cva } from 'class-variance-authority';

export const cardListItemVariants = cva(
  [
    'flex',
    'w-full',
    'rounded-radius-comp-card-list',
    'bg-color-comp-card-list-container-enabled',
    'transition-all',
    'duration-200',
    'ring-2',
    'ring-transparent',
  ],
  {
    variants: {
      state: {
        enabled: [
          'cursor-pointer',
          'hover:bg-color-comp-card-list-container-hover',
        ],
        disabled: [
          'cursor-not-allowed',
          'bg-color-comp-card-list-container-disabled',
        ],
        selected: [
          'cursor-pointer',
          'bg-color-comp-card-list-container-selected',
          'ring-color-comp-form-border-selected',
        ],
        error: ['ring-color-ref-ui-status-danger'],
      },
      size: {
        big: [
          'py-spacing-comp-card-list-big-vertical',
          'px-spacing-comp-card-list-big-horizontal',
          'gap-spacing-comp-card-list-big-gap',
        ],
        medium: [
          'py-spacing-comp-card-list-medium-vertical',
          'px-spacing-comp-card-list-medium-horizontal',
          'gap-spacing-comp-card-list-medium-gap',
        ],
      },
    },
    defaultVariants: {
      state: 'enabled',
      size: 'big',
    },
  },
);

export const cardListItemTitleVariants = cva(
  [
    'truncate',
    'font-sys-family-default',
    'text-font-ref-body-medium-font-size',
    'font-ref-body-bold-font-weight',
    'leading-sys-line-height-24',
    'tracking-font-sys-letter-spacing-0',
  ],
  {
    variants: {
      disabled: {
        false: ['text-color-comp-card-list-on-container-default'],
        true: ['text-color-ref-text-disabled'],
      },
    },
    defaultVariants: {
      disabled: false,
    },
  },
);

export const cardListItemSubtitleVariants = cva(
  [
    'truncate',
    'font-sys-family-default',
    'text-font-ref-labels-medium-font-size',
    'font-ref-body-medium-font-weight',
    'leading-sys-line-height-16',
    'tracking-font-sys-letter-spacing-0',
  ],
  {
    variants: {
      disabled: {
        false: ['text-color-comp-form-label-subtext'],
        true: ['text-color-comp-form-label-disabled'],
      },
    },
    defaultVariants: {
      disabled: false,
    },
  },
);
